import { xhrApiClient } from "@/config/xhrApiClient";

const postPurchaseLimitsCheck = async (payload: any) => {
    const {data} = await xhrApiClient.post('/api/purchase-limits-check', payload)
    return data
}

export default postPurchaseLimitsCheck